        $(document).ready(function() {
          // find all img tags and add the oncontextmenu attribute
          $('img').attr('oncontextmenu', 'return false;');
        });
      
        $("#cart-drawer div:eq(0)").addClass("custom-scroll");
		(function($){
  			$(window).on("load",function(){
				$("#cart-drawer").mCustomScrollbar({
					theme:"minimal"
				});
			});
		})(jQuery);

        $('.moreless-button').click(function() {
          if ($('.moreless-button').text() == "Read more") {
              $(this).text("Read less")
            } else {
              $(this).text("Read more")
          }
          
          $('.moretext').slideToggle();
            
        });


    $(document).ready(function() {
    $('body.product_template.template_.blade-flip-smart-key-for-non-push-start-cars .smart_key_checkbox input').prop('checked', true);
});
      

  $(document).ready(function() {
$('button.button.button--xl.active_btn.smart_key_btn').addClass("my_class"); 
    
    $("buy-buttons.buy-buttons").click(function(){
       $('.model_select').addClass("error_active"); 
    })

    $("#selected_model").click(function(){
       $('button.button.button--xl.active_btn.smart_key_btn').removeClass("my_class"); 
       $('.model_select').removeClass("error_active"); 
      $('.model_select').addClass("remove_pera"); 
    })
});




      
// Selecting elements
const copy_price_pera = document.querySelector('.copy_price_pera');
const codShipping = document.querySelector('.actual-price');
const updated_price = document.getElementById("updated_price");

// Parsing the value from the text content
const value = parseFloat(copy_price_pera.textContent);

// Rounding the price and adding 50
const roundedPricePlus = Math.floor(value);
const pricePlus = roundedPricePlus + 99;
codShipping.innerHTML = `₹${pricePlus}`; // Adding the rupee symbol and updating the innerHTML

// Subtracting 1500 from the rounded price
const minusPrice = roundedPricePlus - 1500;
updated_price.innerHTML = `₹${minusPrice}`; 
 









